import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';

const productImageZoom = () => {

	const init = () => {     
        var elms = $('.mfp-image > a');
        var hasImagePreview = elms.find('img').length ? true : false;

        elms.data('inited', true);
        elms.magnificPopup({
            type: 'image',
            mainClass: 'mfp-with-zoom',
            midClick: true,
            focus: "body",
            tLoading: 'Загрузка…',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            },
            zoom: {
                enabled: hasImagePreview,
                duration: 300,
                easing: 'ease-in-out'
            },
            callbacks: {
           	  change: function() {
           	  	setTimeout( function() {
	           	  	const elMfpPos = $('.mfp-counter');
	           	  	elMfpPos.text( elMfpPos.text().replace( / of /g, ' из ' ));			    
	           	}, 5 );           	  	
			  }			  
			}            
        });    	 
    }

    init();
}

export default productImageZoom;